module.exports = __webpack_public_path__ + "assets/img/0f07f1f366f1eafa2d32c3a7ddd80a67.png";